const CatalogModelMixin = {
  methods: {
    getCatalogModels(catalog, params = {}) {
      const url = route("api.catalogmodels.index", { catalog: catalog });
      return axios.get(url, {
        params: params,
      });
    },

    createCatalogModel(catalog, params) {
      const url = route("api.catalogmodels.store", { catalog: catalog });
      return axios.post(url, params);
    },

    searchCatalogModels(params = {}) {
      const url = route("api.catalogmodels.search");

      return axios.get(url, {
        params: params,
      });
    },

    getCatalogModelShowUrl(catalogmodel) {
      return route("app.catalogmodels.show", {
        year: catalogmodel.year,
        model: catalogmodel.id,
      });
    },
  },
};

export default CatalogModelMixin;
